  <div class="diagnostics-container">
    <section class="diagnostics-section">
      <div class="section-header">
        <div class="diagnostic-header">
          <div class="tab active">
            {{ 'tasks.header' | transloco }}
          </div>
        </div>
      </div>
      <div class="icons-container">
        <span>{{ 'tasks.selectTask' | transloco }}</span>
        <div class="icons">
          <i class="pi pi-search"></i>
          <i class="pi pi-filter"></i>
        </div>
      </div>

      <div class="diagnostic-item" *ngFor="let parameters of parametersTask;">
        <div class="diagnostic-inner">
          <label class="custom-checkbox">
            <input type="checkbox" [value]="parameters" (change)="onCheckboxChange($event, parameters)"
              [checked]="isChecked(parameters)" />
              <span class="checkbox-icon">
                <i class="pi" [ngClass]="{
                  'pi-check': isChecked(parameters),
                  'pi-square': !isChecked(parameters)
                }"></i>
              </span>
            {{parameters.name.name}}
          </label>
          <p>{{parameters.name.description}}</p>
          <div class="project-tags">
            <span class="tag">{{ "adminPanel.general" | transloco }}</span>
            <!-- <span class="tag">Arrancada</span> -->
          </div>
        </div>
      </div>

      <div class="add-task">
        <p-button id="addProjectBtn" name="addProjectBtn" icon=" pi pi-file-plus" iconPos="left" severity="danger"
          [raised]="true" label="{{ 'tasks.buttonAddTask' | transloco }}" (click)="addTask()" [disabled]="!startDiagnostic" />
      </div>
    </section>

    <!-- Histórico -->
    <div>
      <div class="header-tabs">
        <div class="tab active">
          {{ 'tasks.taskHistory' | transloco }}
        </div>
      </div>
      <p-table #usersList [value]="taskList" dataKey="id" [rows]="5" [rowsPerPageOptions]="[5, 15, 30]"
        [loading]="loadingTasksList" [paginator]="true" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'project.detail.tableShare.currentPage' | transloco }}"
        [globalFilterFields]="['name', 'email', 'date']" [tableStyle]="{ 'maz-width': '1366px' }">
        <ng-template pTemplate="caption">
          <div class="g-table-end">
            <p-iconField iconPosition="right" class="ml-auto">
              <p-inputIcon>
                <i class="pi pi-search"></i>
              </p-inputIcon>
              <input pInputText type="text" placeholder="{{ 'project.detail.tableShare.search' | transloco }}" />
            </p-iconField>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name" style="width: 28%">
              {{ "tasks.tableShare.name" | transloco }}
              <p-sortIcon field="name" />
            </th>
            <th pSortableColumn="description" style="width: 28%">
              {{ "tasks.tableShare.description" | transloco }}
              <p-sortIcon field="description" />
            </th>
            <th pSortableColumn="status" style="width: 15%">
              {{ "common.labels.status" | transloco }}
              <p-sortIcon field="status" />
            </th>
            <th style="width: 15%">
              {{ "tasks.tableShare.date" | transloco }}
            </th>
            <th style="width: 20%">
              {{ "tasks.tableShare.action" | transloco }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tasks let-ri="rowIndex">
          <tr>
            <td>
              {{ tasks.name }}
            </td>
            <td>
              {{ tasks.description ? tasks.description : '-'}}
            </td>
            <td>
              {{ getStatusLabel(tasks.status) }}
            </td>
            <td>
              {{ tasks.createdDate | date : "dd/MM/yyyy HH:mm:ss" }}
            </td>
            <td>
              <p-button [rounded]="true" [text]="true" icon="pi pi-pencil" (click)="editTask(tasks)" />
              <p-button [rounded]="true" [text]="true" icon="pi pi-trash" (click)="deleteTask(tasks)" />
              <p-button [rounded]="true" [text]="true" icon="pi pi-eye" (click)="viewTaskResultProgress(tasks)" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">
              {{ "project.detail.tableShare.noFound" | transloco }}.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <p-dialog id="modal-admin-user" [header]="'diagnostics.header' | transloco" [modal]="true" [draggable]="false"
    [(visible)]="displayAddTaskDialog" [dismissableMask]="true" (onHide)="closeModal()"
    [style]="{ 'border-radius': '10px', width: '1100px', 'max-width': '98vw' }">
    <div class="modal-content">
      <form [formGroup]="form">
        <div class="modal-content-page" [(style.display)]="modalpage[0]">
          <div class="row">
            <div class="analysisHeader">
              <span>{{ 'tasks.taskAnalyse' | transloco }}</span>
            </div>
            <div class="analysisSub" *ngFor=" let selectedParam of selectedParameters ">
              <span class="title">{{ selectedParam.name.name }}</span>
              <span class="description">{{ selectedParam.name.description}}</span>
            </div>
          </div>
          <div class="row">
            <div class="analysisHeader">
              <span>{{ 'tasks.generalDate' | transloco }}</span>
            </div>
            <div class="analysisSub">
              <span class="title">{{ 'tasks.taskTitle' | transloco }}</span>
              <input type="text" id="projectName" name="taskName" formControlName="name"
                placeholder="{{ 'tasks.dialog.taskName' | transloco }}" pInputText maxlength="120" />

              <span class="title">{{ 'tasks.description' | transloco }} <span style="font-weight: 100;">{{ 'tasks.optional' | transloco }}</span></span>
              <textarea id="description" name="description" rows="5" cols="30"
                placeholder="{{ 'tasks.dialog.detail' | transloco }}" pInputText formControlName="description" maxlength="1000">
                  </textarea>
            </div>
          </div>
          <div class="row-btn">
            <div class="button-wrapper" (click)="closeModal()">
              <div class="button-inner">
                <p-button id="btnBack" name="btnBack" label="{{ 'tasks.btnCancel' | transloco }}" [raised]="true"
                  styleClass="custom-button"></p-button>
              </div>
            </div>
            <p-button label="{{ 'tasks.dialog.buttonNext' | transloco }}" severity="danger" [raised]="true"
              (click)="nextPage()" [loading]="nextBtnLoading" [disabled]="nextBtnLoading || !form.valid"></p-button>
          </div>
        </div>
        <div class="modal-content-page1" [(style.display)]="modalpage[1]">
          <div class="row">
            <div class="analysisHeader">
              <span>{{createdTaskTitle}}</span>
            </div>
            <div class="analysisSub" *ngFor=" let selectedParam of selectedParameters ">
              <span class="title">{{ selectedParam.name.name }}</span>
              <span class="description">{{ selectedParam.name.description}}</span>
            </div>
          </div>
          <!-- <div class="row">
              <div style="display: flex; flex-direction: column; flex: 1; margin-right: 1rem; width: 100%;">
                <span style="text-align: left; margin-bottom: 0.25rem;">{{ 'tasks.dialog.projectId' | transloco }}</span>
                <p-multiSelect
                  id="projectId"
                  name="projectId"
                  formControlName="projectId"
                  [options]="projectOptions"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="{{ 'tasks.dialog.projectId' | transloco }}"
                />
              </div>
            </div> -->
          <div class="row">
            <div class="analysisHeader">
              <span>{{ 'tasks.archives' | transloco }}</span>
            </div>
            <h3 class="upload-subtitle">{{ 'tasks.logsUpload' | transloco }}</h3>
            <div class="upload-wrapper">
              <div class="upload-inner">
                <div class="upload-area">
                  <label class="upload-btn">
                    <i class="pi pi-upload"></i>
                    Upload
                    <input type="file" multiple (change)="onSelectFile($event)" hidden />
                  </label>
                  <span class="custom-upload-label">
                    {{ 'tasks.instruction' | transloco }}
                  </span>
                </div>
              </div>
            </div>

              <div class="progress-container" *ngIf="progressState == 'start'">
                <div class="progress-bar" [style.width.%]="progressValue"></div>
              </div>
              <span class="progress-label" *ngIf="progressState == 'start'">
                {{ progressValue }}%
              </span>

            <div class="file-list">
              <div class="file-item" *ngFor="let file of uploadedFiles">
                <span class="file-name">{{ file.name }}</span>
                <span class="file-size">{{ file.size | number }} bytes</span>
                <button type="button" class="delete-button" (click)="removeFile(file)">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>

          </div>
          <div class="row-btn">
            <div class="button-wrapper">
              <div class="button-inner">
                <p-button id="btnBack" name="btnBack" label="{{ 'project.register.backBtn' | transloco }}"
                  [raised]="true" (click)="backPage(1)" styleClass="custom-button"></p-button>
              </div>
            </div>
            <p-button [label]="'diagnostics.generateDiagnostic' | transloco" severity="danger" [raised]="true" [loading]="loadingSaveTask"
              [disabled]="disableSaveTask" (click)="saveTaskAndFiles()"></p-button>
          </div>
        </div>
        <div class="modal-content-page2" [(style.display)]="modalpage[2]">
          <div class="row">
            <div *ngIf="statusDiagnostic == 'success'">
            <div class="analysisStatus">
              <span class="title"><i class="pi pi-check-circle"></i></span>
              <span class="title">{{ 'tasks.dialog.success.successMessage' | transloco }}</span>
            </div>
            <div class="row-btn" style="justify-content: center; gap: 2rem; margin-top: 30px;">
              <div class="button-wrapper">
                  <p-button icon="pi pi-eye" iconPosition="left" id="btnBack" name="btnBack" label="{{ 'tasks.dialog.success.btnDiagnostics' | transloco }}" [raised]="true"
                   styleClass="custom-button"></p-button>
              </div>
              <p-button icon="pi pi-download" iconPosition="left" [label]="'common.buttons.download' | transloco" severity="danger" [raised]="true" [loading]="loadingSaveTask"
                [disabled]="disableSaveTask" ></p-button>
            </div>
            <div class="row">
              <div class="analysisHeader">
                <span>{{ 'tasks.dialog.success.analyseDetails' | transloco }}</span>
              </div>
              <div class="analysisSub" *ngFor="let selectedParam of selectedParameters">
                <span class="title">{{ selectedParam.name.name }}</span>
                <span class="description">{{ selectedParam.name.description}}</span>
              </div>
              <div class="analysisSub">
                <span class="title">{{ 'tasks.dialog.success.analysedLogs' | transloco }}</span>
              </div>
            </div>
            
              <p-table
               #dtLog
               [value]="uploadedFiles"
               dataKey="name"
               [rows]="5"
               [tableStyle]="{ 'min-width': '20rem', width: '100%' }"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 5%;"></th>
                    <th pSortableColumn="name" style="width: 35%">
                      {{ "project.register.upload.name" | transloco }}
                      <p-sortIcon field="date" />
                    </th>
                    <th style="width: 35%">
                      {{ "project.register.upload.size" | transloco }}
                    </th>
                    <th>
                      {{"project.detail.tableLog.date" | transloco}}
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file>
                  <tr>
                    <td>
                      <div class="center-column">
                        <i class="pi pi-file" style="font-size: 1.5rem;"></i>
                      </div>
                    </td>
                    <td>
                      <div class="center-column">
                        {{ file.name }}
                      </div>
                    </td>
                    <td>{{ file.size | number }} bytes</td>
                    <td>{{ file.file.lastModifiedDate | date : "dd/MM/yyyy" }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">
                      {{ "project.register.upload.empty" | transloco }}.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <div *ngIf="statusDiagnostic == 'error'">
              <div class="analysisStatus">
              <span class="title"><i class="pi pi-times-circle"></i></span>
              <span class="title">{{ 'tasks.dialog.failure.failureMessage' | transloco }}</span>
              <span class="description">{{ 'tasks.dialog.success.description1' | transloco }}</span>
              <span class="description">{{ 'tasks.dialog.success.description2' | transloco }}, <strong>{{ 'tasks.dialog.success.description3' | transloco }}</strong></span>
            </div>
              
            <div class="row">
              <div class="analysisHeader">
                <span>{{ 'tasks.dialog.success.analyseDetails' | transloco }}</span>
              </div>
              <div class="analysisSub" *ngFor="let selectedParam of selectedParameters">
                <span class="title">{{ selectedParam.name.name }}</span>
                <span class="description">{{ selectedParam.name.description}}</span>
              </div>
              <div class="analysisSub">
                <span class="title">{{ "diagnostics.logs" | transloco }}</span>
              </div>
            </div>
            
              <p-table
               #dtLog
               [value]="uploadedFiles"
               dataKey="name"
               [rows]="5"
               [tableStyle]="{ 'min-width': '20rem', width: '100%' }"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 5%;"></th>
                    <th pSortableColumn="name" style="width: 35%">
                      {{ "project.register.upload.name" | transloco }}
                      <p-sortIcon field="date" />
                    </th>
                    <th style="width: 35%">
                      {{ "project.register.upload.size" | transloco }}
                    </th>
                    <th>
                      {{"project.detail.tableLog.date" | transloco}}
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file>
                  <tr>
                    <td>
                      <div class="center-column">
                        <i class="pi pi-file" style="font-size: 1.5rem;"></i>
                      </div>
                    </td>
                    <td>
                      <div class="center-column">
                        {{ file.name }}
                      </div>
                    </td>
                    <td>{{ file.size | number }} bytes</td>
                    <td>{{ file.file.lastModifiedDate | date : "dd/MM/yyyy" }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">
                      {{ "project.register.upload.empty" | transloco }}.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="button-wrapper">
            <div class="button-inner">
              <p-button id="btnBack" name="btnBack" [label]="'common.buttons.close' | transloco" [raised]="true"
                (click)="closeModal()" styleClass="custom-button"></p-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </p-dialog>
    <p-dialog
      id="modal-task-result"
      [header]="('diagnostics.headerWithName' | transloco:{ taskName: taskName })"
      [modal]="true"
      [draggable]="false"
      [(visible)]="displayTaskResultDialog"
      [dismissableMask]="true"
      (onHide)="closeModal()"
      [style]="{ 'border-radius': '10px', width: 'auto', 'max-width': '98vw', 'max-height':'95%' }"
    >
      <div class="modal-content " [ngClass]="{'result': !loadingTaskResult}">
        <div class="row">
           <div class="overlay" *ngIf="loadingTaskResult">
              <!-- <p-progressSpinner styleClass="large-spinner"></p-progressSpinner> -->

              
              <div  style="margin-top: 100px;">
                <p>{{loadingName}}</p>
                <div class="progress-container">
                  <div [style.width.%]="progress" class="progress-bar striped animated"></div>
                </div>
                <span class="progress-percentage">{{progress}}%</span>
              </div>


          </div>
           
          
          <div class="tabs" *ngIf="!loadingTaskResult">
            <button
              *ngFor="let tab of tabs; let i = index"
              (click)="setActiveTab(tab.id)"
              [class.active]="activeTab === tab.id"
            >
                <i *ngIf="activeTab === tab.id" class="mb-4 pi pi-chevron-down text-2xl text-muted-color"></i>
                <i *ngIf="activeTab !== tab.id" class="mb-4 pi pi-chevron-left text-2xl text-muted-color"></i>
            </button>
          </div>

          <div class="tab-content" *ngIf="tabs.length > 0">
            <div [innerHTML]="htmlcontent"></div>
          </div>


           
            
        </div>
      </div>
    </p-dialog>
  <p-toast key="toastTask" />